import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import { InputAdornment } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import { ErrorMessage } from 'formik'

const EPFEmployeeOneTwo = [
  {
    id: 0,
    epf_rate: '9%',
  },
  {
    id: 1,
    epf_rate: '11%',
  },
  {
    id: 2,
    epf_rate: 'Custom',
  },
]

const EPFEmployeeThreeFour = [
  {
    id: 0,
    epf_rate: '5.5%',
  },
  {
    id: 2,
    epf_rate: 'Custom',
  },
]

const EPFEmployeeFive = [
  {
    id: 0,
    epf_rate: '0%',
  },
  {
    id: 2,
    epf_rate: 'Custom',
  },
]

const EPFEmployerRate = [
  {
    id: 0,
    epf_rate: 'Fixed',
  },
  {
    id: 1,
    epf_rate: 'Custom',
  },
]

const SOCSOWorkerTypeOptions = [
  { id: 1, label: 'Local employee' },
  { id: 2, label: 'Foreign worker' },
]

const EditBankTab = ({
  formikBag,
  salCat,
  bankDropdown,
  EPFCategory,
  SOCSOCategoryLocal,
  SOCSOCategoryForeign,
  SOCSOWorkerTypeOptions,
  companyHrdfStatus,
}) => {
  // ⬇️ THIS LINE IS MISSING IN YOUR FILE
  const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formikBag

  // Now you can safely use `values` below
  const categoryOptions =
    values.socso_worker_type === 2 ? SOCSOCategoryForeign : SOCSOCategoryLocal


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            p: 2,
            alignItems: 'center',
          }}
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Salary details
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <Box gap={2.5} display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
            <Box width={{ xs: '100%', sm: '30%' }}>
              <AdxDropdown
                label="Salary category"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                name="salary_category"
                value={values.salary_category}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={<ErrorMessage name="salary_category" component={AdxErrorMessage} />}
                isErrorShown={touched.salary_category && errors.salary_category}
              >
                {salCat &&
                  salCat?.map((item) => (
                    <AdxMenuItem value={item.id} selectedvalue={values.salary_category}>
                      {item.description}
                    </AdxMenuItem>
                  ))}
              </AdxDropdown>
            </Box>
            <Box width={{ xs: '100%', sm: '60%' }} sx={{ display: 'flex', alignItems: 'center' }}>
              <AdxInput
                label="Basic salary"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="XX,XXX"
                name="basic_salary"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.basic_salary}
                errorMessage={<ErrorMessage name="basic_salary" component={AdxErrorMessage} />}
                isErrorShown={touched.basic_salary && errors.basic_salary}
                startAdornment={<InputAdornment position="start">RM</InputAdornment>}
                sx={{ width: { xs: '70%', sm: '50%' }, mr: 1 }}
              />
              <Typography sx={{ pt: 3 }} variant="body1" color="light-gray-text.main">
                {values.salary_category
                  ? values.salary_category === 0
                    ? 'none'
                    : values.salary_category === 1
                      ? 'per hour'
                      : values.salary_category === 2
                        ? 'per day'
                        : values.salary_category === 3
                          ? 'per month'
                          : 'undefined'
                  : ''}
              </Typography>
            </Box>
          </Box>
          <Box gap={2.5} display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
            <Box width={{ xs: '100%', sm: '60%' }}>
              <AdxDropdown
                label="Bank name"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                name="bank_id"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bank_id}
                errorMessage={<ErrorMessage name="bank_id" component={AdxErrorMessage} />}
                isErrorShown={touched.bank_id && errors.bank_id}
              >
                {bankDropdown &&
                  bankDropdown.map((bankName) => (
                    <AdxMenuItem value={bankName.id} selectedvalue={values.bank_id}>
                      {bankName.name}
                    </AdxMenuItem>
                  ))}
              </AdxDropdown>
            </Box>
            <Box width={{ xs: '100%', sm: '40%' }}>
              <AdxInput
                label="Bank account no."
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="Bank account no."
                name="bank_acc_number"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bank_acc_number}
                errorMessage={<ErrorMessage name="bank_acc_number" component={AdxErrorMessage} />}
                isErrorShown={touched.bank_acc_number && errors.bank_acc_number}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            p: 2,
            alignItems: 'center',
          }}
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Statutory body details
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <Box>
            <AdxDropdown
              label="EPF contribution status"
              size="standard"
              name="epf_status"
              value={values.epf_status}
              onChange={(event) => {
                if (values.epf_status === 1) {
                  if (event.target.value !== 1) {
                    setFieldValue(`epf_category`, { id: 0, category: 'No Category' })
                    setFieldValue(`epf_acc_number`, null)
                    setFieldValue(`epf_employee_contribution_rate`, 0)
                    setFieldValue(`employee_custom_contribution_rate`, 0)
                    setFieldValue(`epf_employer_contribution_rate`, 0)
                    setFieldValue(`employer_custom_contribution_rate`, 0)
                  }
                } else {
                  if (event.target.value === 1) {
                    setFieldValue(`epf_category`, null)
                    setFieldValue(`epf_acc_number`, null)
                    setFieldValue(`epf_employee_contribution_rate`, null)
                    setFieldValue(`employee_custom_contribution_rate`, 0)
                    setFieldValue(`epf_employer_contribution_rate`, null)
                    setFieldValue(`employer_custom_contribution_rate`, 0)
                  } else {
                    setFieldValue(`epf_category`, { id: 0, category: 'No Category' })
                    setFieldValue(`epf_acc_number`, null)
                    setFieldValue(`epf_employee_contribution_rate`, 0)
                    setFieldValue(`employee_custom_contribution_rate`, 0)
                    setFieldValue(`epf_employer_contribution_rate`, 0)
                    setFieldValue(`employer_custom_contribution_rate`, 0)
                  }
                }
                handleChange(event)
              }}
              onBlur={handleBlur}
              sx={{ width: { xs: '100%', sm: '30%' } }}
              errorMessage={<ErrorMessage name="epf_status" component={AdxErrorMessage} />}
              isErrorShown={touched.epf_status && errors.epf_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.epf_status}>
                Yes
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.epf_status}>
                No
              </AdxMenuItem>
            </AdxDropdown>
          </Box>

          <Box width={'100%'} gap={2.5} display="flex" alignItems="center">
            <AdxDropdown
              label="EPF contribution category"
              disabled={values.epf_status === 1 ? false : true}
              size="standard"
              placeholder="EPF contribution category"
              name="epf_category"
              value={values.epf_category}
              onChange={(tre) => {
                // Category 1 or 2
                if (values?.epf_category?.id === 1 || values?.epf_category?.id === 2) {
                  if (tre.target.value.id === 1 || tre.target.value.id === 2) {
                    handleChange(tre)
                  } else {
                    handleChange(tre)
                    setFieldValue(`epf_employee_contribution_rate`, null)
                  }
                }
                // Category 3, 4 or 5
                else {
                  if (tre.target.value.id === 1 || tre.target.value.id === 2) {
                    handleChange(tre)
                    setFieldValue(`epf_employee_contribution_rate`, null)
                  } else {
                    handleChange(tre)
                  }
                }
              }}
              onBlur={handleBlur}
              renderValue={(value) => (
                <Box>
                  <Typography>{value.category}</Typography>
                </Box>
              )}
              errorMessage={<ErrorMessage name="epf_category" component={AdxErrorMessage} />}
              isErrorShown={touched.epf_category && errors.epf_category}
              sx={{ width: '90%' }}
            >
              {EPFCategory.map((item) => (
                <AdxMenuItem value={item} selectedvalue={values.epf_category}>
                  <Box p={2}>
                    <Typography color="dark-text.main" pb={0.375}>
                      {item.category}
                    </Typography>
                    <Typography color="light-gray-text.main">{item.description}</Typography>
                  </Box>
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>
          <Box>
            <AdxInput
              label="EPF account no."
              disabled={values.epf_status === 1 ? false : true}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="EPF account no."
              name="epf_acc_number"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.epf_acc_number}
              sx={{ width: '100%' }}
              errorMessage={<ErrorMessage name="epf_acc_number" component={AdxErrorMessage} />}
              isErrorShown={touched.epf_acc_number && errors.epf_acc_number}
            />
          </Box>

          <Box gap={2.5} display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
            <Box width={{ xs: '100%', sm: '30%' }}>
              <AdxDropdown
                label="Employee EPF Rate"
                disabled={values.epf_status === 1 ? false : true}
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="Employee EPF Rate"
                name="epf_employee_contribution_rate"
                value={values.epf_employee_contribution_rate}
                onChange={(event) => {
                  setFieldValue(`employee_custom_contribution_rate`, 0)
                  handleChange(event)
                }}
                onBlur={handleBlur}
                errorMessage={
                  <ErrorMessage name="epf_employee_contribution_rate" component={AdxErrorMessage} />
                }
                isErrorShown={
                  touched.epf_employee_contribution_rate && errors.epf_employee_contribution_rate
                }
              >
                {values?.epf_category?.id === 1 || values?.epf_category?.id === 2
                  ? EPFEmployeeOneTwo.map((rate) => (
                    <AdxMenuItem
                      value={rate.id}
                      selectedvalue={values.epf_employee_contribution_rate}
                    >
                      {rate.epf_rate}
                    </AdxMenuItem>
                  ))
                  : values?.epf_category?.id === 3 || values?.epf_category?.id === 4
                    ? EPFEmployeeThreeFour.map((rate) => (
                      <AdxMenuItem
                        value={rate.id}
                        selectedvalue={values.epf_employee_contribution_rate}
                      >
                        {rate.epf_rate}
                      </AdxMenuItem>
                    ))
                    : EPFEmployeeFive.map((rate) => (
                      <AdxMenuItem
                        value={rate.id}
                        selectedvalue={values.epf_employee_contribution_rate}
                      >
                        {rate.epf_rate}
                      </AdxMenuItem>
                    ))}
              </AdxDropdown>
            </Box>
            <Box width={{ xs: '100%', sm: '15%' }}>
              {values.epf_employee_contribution_rate === 2 && (
                <AdxInput
                  label="Custom rate"
                  disabled={values.epf_status === 1 ? false : true}
                  sxLabel={{
                    color: 'dark-text.main',
                  }}
                  sxInput={{
                    color: 'light-gray-text.main',
                    backgroundColor: 'white.main',
                  }}
                  size="standard"
                  placeholder="Custom rate"
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  name="employee_custom_contribution_rate"
                  value={values.employee_custom_contribution_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={
                    <ErrorMessage
                      name="employee_custom_contribution_rate"
                      component={AdxErrorMessage}
                    />
                  }
                  isErrorShown={
                    touched.employee_custom_contribution_rate &&
                    errors.employee_custom_contribution_rate
                  }
                />
              )}
            </Box>
          </Box>
          <Box gap={2.5} display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
            <Box width={{ xs: '100%', sm: '30%' }}>
              <AdxDropdown
                label="Employer EPF Rate"
                disabled={values.epf_status === 1 ? false : true}
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="Employer EPF Rate"
                name="epf_employer_contribution_rate"
                value={values.epf_employer_contribution_rate}
                onChange={(event) => {
                  setFieldValue(`employer_custom_contribution_rate`, 0)
                  handleChange(event)
                }}
                onBlur={handleBlur}
                errorMessage={
                  <ErrorMessage name="epf_employer_contribution_rate" component={AdxErrorMessage} />
                }
                isErrorShown={
                  touched.epf_employer_contribution_rate && errors.epf_employer_contribution_rate
                }
                sx={{ mb: 6.25 }}
              >
                {EPFEmployerRate.map((rate) => (
                  <AdxMenuItem
                    value={rate.id}
                    selectedvalue={values.epf_employer_contribution_rate}
                  >
                    {rate.epf_rate}
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
            </Box>
            <Box width={{ xs: '100%', sm: '15%' }}>
              {values.epf_employer_contribution_rate === 1 && (
                <AdxInput
                  label="Custom rate"
                  disabled={values.epf_status === 1 ? false : true}
                  sxLabel={{
                    color: 'dark-text.main',
                  }}
                  sxInput={{
                    color: 'light-gray-text.main',
                    backgroundColor: 'white.main',
                  }}
                  size="standard"
                  placeholder="Custom rate"
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  value={values.employer_custom_contribution_rate}
                  name="employer_custom_contribution_rate"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={
                    <ErrorMessage
                      name="employer_custom_contribution_rate"
                      component={AdxErrorMessage}
                    />
                  }
                  isErrorShown={
                    touched.employer_custom_contribution_rate &&
                    errors.employer_custom_contribution_rate
                  }
                />
              )}
            </Box>
          </Box>




          {/* SOCSO worker type */}
          <Box width={{ xs: '100%', sm: '30%' }}>
            <AdxDropdown
              label="SOCSO worker type"
              sxLabel={{ color: 'dark-text.main' }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="SOCSO worker type"
              name="socso_worker_type"
              value={values.socso_worker_type ?? 1}
              onChange={(event) => {
                const prevType = values.socso_worker_type ?? 1
                const newType = Number(event.target.value)

                // update Formik value
                handleChange(event)

                // Foreign worker
                if (newType === 2) {
                  // force EIS = No
                  setFieldValue('eis_status', 0)

                  // adjust SOCSO category list if SOCSO is active
                  if (values.socso_status === 1) {
                    const list = SOCSOCategoryForeign
                    const nextCategory =
                      values.socso_category &&
                        list.some((c) => c.id === values.socso_category.id)
                        ? list.find((c) => c.id === values.socso_category.id)
                        : list[0]
                    setFieldValue('socso_category', nextCategory || null)
                  } else {
                    setFieldValue('socso_category', null)
                  }
                }

                // Back to local employee
                if (prevType === 2 && newType === 1) {
                  if (values.socso_status === 1) {
                    const list = SOCSOCategoryLocal
                    const nextCategory =
                      values.socso_category &&
                        list.some((c) => c.id === values.socso_category.id)
                        ? list.find((c) => c.id === values.socso_category.id)
                        : list[0]
                    setFieldValue('socso_category', nextCategory || null)
                  } else {
                    setFieldValue('socso_category', null)
                  }

                  // If previously forced to 0, allow HR to turn EIS back on by defaulting to Yes
                  if (values.eis_status === 0) {
                    setFieldValue('eis_status', 1)
                  }
                }
              }}
              onBlur={handleBlur}
              errorMessage={
                <ErrorMessage name="socso_worker_type" component={AdxErrorMessage} />
              }
              isErrorShown={touched.socso_worker_type && errors.socso_worker_type}
            >
              {SOCSOWorkerTypeOptions.map((opt) => (
                <AdxMenuItem
                  key={opt.id}
                  value={opt.id}
                  selectedvalue={values.socso_worker_type ?? 1}
                >
                  {opt.label}
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>

          {/* SOCSO status */}
          <Box width={{ xs: '100%', sm: '30%' }}>
            <AdxDropdown
              label="SOCSO contribution status"
              sxLabel={{ color: 'dark-text.main' }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="SOCSO contribution status"
              name="socso_status"
              value={values.socso_status}
              onChange={(event) => {
                const nextStatus = Number(event.target.value)

                if (values.socso_status === 1 && nextStatus !== 1) {
                  // turning OFF
                  setFieldValue('socso_category', null)
                  setFieldValue('socso_acc_number', null)
                }

                if (nextStatus === 1) {
                  // turning ON → prefill category if empty
                  const workerType = values.socso_worker_type ?? 1
                  const list =
                    workerType === 2 ? SOCSOCategoryForeign : SOCSOCategoryLocal

                  if (!values.socso_category) {
                    setFieldValue('socso_category', list[0] || null)
                  }
                }

                handleChange(event)
              }}
              onBlur={handleBlur}
              errorMessage={
                <ErrorMessage name="socso_status" component={AdxErrorMessage} />
              }
              isErrorShown={touched.socso_status && errors.socso_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.socso_status}>
                Yes
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.socso_status}>
                No
              </AdxMenuItem>
            </AdxDropdown>
          </Box>

          <Box width={{ xs: '100%', sm: '30%' }}>
            <AdxDropdown
              label="SOCSO worker"
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="SOCSO contribution status"
              name="socso_status"
              value={values.socso_status}
              onChange={(event) => {
                if (values.socso_status === 1) {
                  if (event.target.value !== 1) {
                    setFieldValue(`socso_category`, null)
                    setFieldValue(`socso_acc_number`, null)
                  }
                }
                handleChange(event)
              }}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="socso_status" component={AdxErrorMessage} />}
              isErrorShown={touched.socso_status && errors.socso_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.socso_status}>
                Malaysian
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.socso_status}>
                Foreign
              </AdxMenuItem>
            </AdxDropdown>
          </Box>

          {/* SOCSO category */}
          <Box width={'100%'} gap={2.5} display="flex" alignItems="center">
            <Box width={'90%'}>
              <AdxDropdown
                label="SOCSO contribution category"
                disabled={values.socso_status !== 1}
                sxLabel={{ color: 'dark-text.main' }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="SOCSO contribution category"
                name="socso_category"
                value={values.socso_category}
                onChange={handleChange}
                onBlur={handleBlur}
                renderValue={(value) => (
                  <Box>
                    <Typography>{value.category}</Typography>
                  </Box>
                )}
                errorMessage={
                  <ErrorMessage name="socso_category" component={AdxErrorMessage} />
                }
                isErrorShown={touched.socso_category && errors.socso_category}
              >
                {categoryOptions.map((item) => (
                  <AdxMenuItem
                    key={item.id}
                    value={item}
                    selectedvalue={values.socso_category}
                  >
                    <Box p={2}>
                      <Typography color="dark-text.main" pb={0.375}>
                        {item.category}
                      </Typography>
                      <Typography color="light-gray-text.main">
                        {item.description}
                      </Typography>
                    </Box>
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
            </Box>
          </Box>

          {/* SOCSO account */}
          <Box width={'100%'}>
            <AdxInput
              label="SOCSO account no."
              disabled={values.socso_status !== 1}
              sxLabel={{ color: 'dark-text.main' }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="SOCSO account no."
              name="socso_acc_number"
              value={values.socso_acc_number}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={
                <ErrorMessage name="socso_acc_number" component={AdxErrorMessage} />
              }
              isErrorShown={touched.socso_acc_number && errors.socso_acc_number}
            />
          </Box>

          {/* EIS status */}
          <Box width={{ xs: '100%', sm: '30%' }}>
            <AdxDropdown
              label="EIS contribution status"
              sxLabel={{ color: 'dark-text.main' }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="EIS contribution status"
              name="eis_status"
              value={values.eis_status}
              disabled={values.socso_worker_type === 2} // foreign worker = read-only
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="eis_status" component={AdxErrorMessage} />}
              isErrorShown={touched.eis_status && errors.eis_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.eis_status}>
                Yes
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.eis_status}>
                No
              </AdxMenuItem>
            </AdxDropdown>

            {values.socso_worker_type === 2 && (
              <Typography variant="caption" color="light-gray-text.main" sx={{ mt: 0.5 }}>
                Foreign workers are not covered by EIS. EIS is for Malaysian citizens only.
              </Typography>
            )}
          </Box>







          {companyHrdfStatus === 1 && (
            <Box width={{ xs: '100%', sm: '30%' }}>
              <AdxDropdown
                label="HRDF levy status"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="HRDF levy status"
                value={values.hrdf_status}
                name="hrdf_status"
                onChange={handleChange}
                sx={{ mb: 6.5 }}
                errorMessage={<ErrorMessage name="hrdf_status" component={AdxErrorMessage} />}
                isErrorShown={touched.hrdf_status && errors.hrdf_status}
              >
                <AdxMenuItem value={1} selectedvalue={values.hrdf_status}>
                  Yes
                </AdxMenuItem>
                <AdxMenuItem value={0} selectedvalue={values.hrdf_status}>
                  No
                </AdxMenuItem>
              </AdxDropdown>
            </Box>
          )}
          <Box width={{ xs: '100%', sm: '30%' }}>
            <AdxDropdown
              label="Zakat contribution status"
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Zakat contribution status"
              name="zakat_status"
              onChange={(event) => {
                if (values.zakat_status === 1) {
                  if (event.target.value !== 1) {
                    setFieldValue(`zakat_acc_number`, null)
                  }
                }
                setFieldValue(`zakat_amount`, 0)
                handleChange(event)
              }}
              onBlur={handleBlur}
              value={values.zakat_status}
              errorMessage={<ErrorMessage name="zakat_status" component={AdxErrorMessage} />}
              isErrorShown={touched.zakat_status && errors.zakat_status}
              sx={{ mb: 2.5 }}
            >
              <AdxMenuItem value={1} selectedvalue={values.zakat_status}>
                Yes
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.zakat_status}>
                No
              </AdxMenuItem>
            </AdxDropdown>
          </Box>
          {values.zakat_status === 1 && (
            <>
              {' '}
              <Box width={'100%'}>
                <AdxInput
                  label="Zakat Account Number"
                  sxLabel={{
                    color: 'dark-text.main',
                    // fontSize: "30px!important",
                  }}
                  sxInput={{
                    color: 'light-gray-text.main',
                    backgroundColor: 'white.main',
                  }}
                  size="standard"
                  placeholder="Zakat Account Number"
                  name="zakat_acc_number"
                  value={values.zakat_acc_number}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={
                    <ErrorMessage name="zakat_acc_number" component={AdxErrorMessage} />
                  }
                  isErrorShown={touched.zakat_acc_number && errors.zakat_acc_number}
                  sx={{ mb: 2.5 }}
                />
              </Box>
              <Box width={{ xs: '100%', sm: '60%' }} sx={{ display: 'flex', alignItems: 'center' }}>
                <AdxInput
                  label="Zakat amount"
                  sxLabel={{
                    color: 'dark-text.main',
                    // fontSize: "30px!important",
                  }}
                  sxInput={{
                    color: 'light-gray-text.main',
                    backgroundColor: 'white.main',
                  }}
                  size="standard"
                  placeholder="XX,XXX"
                  name="zakat_amount"
                  value={values.zakat_amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={<ErrorMessage name="zakat_amount" component={AdxErrorMessage} />}
                  isErrorShown={touched.zakat_amount && errors.zakat_amount}
                  startAdornment={<InputAdornment position="start">RM</InputAdornment>}
                  sx={{ width: { xs: '70%', sm: '50%' }, mr: 1 }}
                />
                <Typography sx={{ pt: 3 }} variant="body1" color="light-gray-text.main">
                  (per month)
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default EditBankTab
